




































































import Vue from 'vue'
import { Store, Price } from '../../types'
export default Vue.extend({
	name: 'Init',
	data() {
		return {
			models: [] as any,
			model: null,
			carriers: [] as Store[],
			useFor: 24,
			prices: [] as Price[]
		}
	},
	mounted: async function() {
		const models = await (await fetch(`/assets/list.json`)).json()
		const ml = {} as any
		for (const m of models) {
			ml[m.cat] ? ml[m.cat].push(m) : (ml[m.cat] = [m])
		}
		const ma = []
		for (const [key, value] of Object.entries(ml)) {
			ma.push({
				name: key,
				models: value
			})
		}
		this.models = ma
	},
	methods: {
		deviceChange: async function() {
			if (!this.model) return false
			const data = await (await fetch(`/assets/${this.model}`)).json()
			this.carriers = data
		},
		calc: function() {
			const carriers = (document as any).carrierSelect.carrier
			const prices = [] as Price[]
			for (const car of carriers) {
				const ca = car.value
				if (!car.checked) continue
				const pureStoreName = ca.replace('UseProgram', '').replace('1', '')
				const c = this.getCarrierData(pureStoreName)
				const obj = {} as Price
				const types = (document as any).typeSelect.type
				let type = 'discountWhenNew' as 'discountWhenNew' | 'discountWhenMNP' | 'discountWhenChange'
				for (const t of types) {
					const ta = t.value
					if (!t.checked) continue
					if (ta === 'mnp') type = 'discountWhenMNP'
					if (ta === 'change') type = 'discountWhenChange'
				}
				const discount = c[type]
				const totalPrice = c.totalPrice - discount
				if (ca.includes('UseProgram')) {
					const useFor = this.useFor >= c.returnableAfter || !c.returnableAfter ? this.useFor : c.returnableAfter
					if (this.useFor < c.returnableAfter && c.returnableAfter) obj.message = `${c.returnableAfter}か月(返却までの最低利用期間)以上利用したときの計算結果です。`
					const requiredReturn = !!c.returnableAfter
					obj.requiredReturn = requiredReturn
					obj.name = `${c.storeName}(${c.splitMonthsWhenProgram}回分割)`
					//2段階であれば残価を引いてそれを分割する
					const monthly1 = c.twoStepsLoan ? (totalPrice - (c.restWhenOneStepPrice || c.restWhenOneStepRate * c.totalPrice)) / (c.oneStep - 1) : c.totalPrice / c.splitMonthsWhenProgram
					obj.first = monthly1 + c.programJoinFee

					obj.monthly1 = monthly1
					//2段階で再分割前に終了したとき
					if (c.twoStepsLoan && useFor < c.oneStep) {
						const lastBefore = totalPrice - (c.restWhenOneStepPrice || c.restWhenOneStepRate * totalPrice) - useFor * monthly1
						const last = lastBefore - (c.ifReturnBeforeTotal || c.ifReturnBeforeByMonth * (c.oneStep - 1 - useFor))
						obj.last = last < 1 ? 0 : last
						obj.monthly2Str = `${c.oneStep}か月まで支払う場合`
						obj.monthly2 = obj.last / (c.oneStep - 1 - useFor || 1)
						obj.total = monthly1 * useFor + c.programJoinFee + last
					}
					//2段階で再度分割されたとき
					if (c.twoStepsLoan && useFor >= c.oneStep) {
						const rest = c.restWhenOneStepPrice || c.restWhenOneStepRate * totalPrice
						const monthly2 = rest / (c.splitMonthsWhenProgram - c.oneStep)
						obj.monthly2 = monthly2
						obj.monthly2Str = `${c.oneStep + 1}か月目以降`
						obj.total = monthly1 * (c.oneStep - 1) + c.programJoinFee + monthly2 * (useFor - c.oneStep + 1)
						obj.last = 0
					}
					//通常の分割で、返却可能な場合(強制的に使用)
					if (!c.twoStepsLoan && requiredReturn) {
						const useForMax = useFor > c.returnableAfter ? c.returnableAfter : useFor
						obj.last = 0
						obj.total = monthly1 * useForMax + c.programJoinFee
					}
					//通常の分割で、返却が不要な場合
					if (!c.twoStepsLoan && !requiredReturn) {
						const useForMax = useFor > c.splitMonthsWhenProgram ? c.splitMonthsWhenProgram : useFor
						obj.last = totalPrice - monthly1 * useForMax
						obj.total = totalPrice + c.programJoinFee
					}
				} else {
					obj.name = `${c.storeName}(一括)`
					obj.first = totalPrice
					obj.monthly1 = 0
					obj.last = 0
					obj.total = totalPrice
					obj.requiredReturn = false
				}
				prices.push(obj)
			}
			console.log(prices)
			this.prices = prices
			return true
		},
		getCarrierData: function(pureStoreName: string) {
			for (const c of this.carriers) {
				if (c.storeId === pureStoreName) return c
			}
			return this.carriers[0]
		}
	}
})
